import html2canvas from "html2canvas-pro";
import jsPDF from "jspdf";


const printOnePage = async (firstPageRef) => {

    const pdf = new jsPDF('p', 'mm', 'letter', true);

    const firstPageCanvas = await html2canvas(firstPageRef.current, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
        scrollX: 0,
        scrollY: 0
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const firstPageimgData = firstPageCanvas.toDataURL('image/png');


    pdf.addImage(firstPageimgData, 'PNG', 0, 0, pageWidth, pageHeight);


    const pdfBlob = pdf.output('blob');
    return pdfBlob;
};

export default printOnePage;